import * as React from 'react';
import { useMemo } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import { useRouter } from 'next/router';

import { RelativeTime } from '@blockworks/ui';
import { RenderSimpleHtml } from '@blockworks/ui/legacy';

import { Link } from '@/components/common';
import PlayPauseIcon from '@/components/pages/podcast/components/play-pause-icon';
import { useAudioPlayer } from '@/components/pages/podcast/layout/audio-provider';
import { Container } from '@/components/pages/podcast/layout/container';
import { linkify } from '@/utils/functions/string/linkify';

const EpisodeEntry = ({ episode }: any) => {
    const router = useRouter();
    const slug = router.query.slug as string;
    const dateTimestamp = new Date(episode.pubdate).getTime();

    const audioPlayerData = useMemo(
        () => ({
            title: episode.title,
            show: episode.podcastTitle,
            audio: {
                src: episode.downloadUrl,
                type: 'mp3',
            },
            link: `/podcast/${slug}/${episode.id}`,
        }),
        [episode, slug],
    );
    const player = useAudioPlayer(audioPlayerData);
    const summary = linkify(
        DOMPurify.sanitize(episode.summary)
            .replace(/<\/?[^>]+(>|$)/g, '')
            .split(' ')
            .slice(0, 32)
            .join(' '),
    );

    return (
        <article aria-labelledby={`episode-${episode.id}-title`} className="py-10 sm:py-12">
            <Container className="">
                <div className="flex flex-col items-start">
                    <h2 id={`episode-${episode.id}-title`} className="mt-2 text-lg font-bold text-slate-900">
                        <Link href={`/podcast/${slug}/${episode.id}`} className="hover:text-brand">
                            {/* <Link  href={`/${episode.id}`}>{episode.title}</Link> */}
                            <span>{episode.title}</span>
                        </Link>
                    </h2>
                    {dateTimestamp && (
                        <RelativeTime
                            date={dateTimestamp / 1000}
                            className="order-first font-mono text-sm leading-7 text-slate-500"
                        />
                    )}
                    <div className="mt-1 text-base leading-7 text-slate-500 h-30 overflow-hidden">
                        <RenderSimpleHtml html={`${summary}..`} />
                    </div>
                    <div className="mt-4 flex items-center gap-4">
                        <a
                            onClick={() => player.toggle()}
                            className="flex items-center text-sm font-bold leading-6 text-brand hover:text-gray-700 active:text-gray-900 cursor-pointer"
                            aria-label={`${player.playing ? 'Pause' : 'Play'} episode ${episode.title}`}
                        >
                            <PlayPauseIcon playing={player.playing} className="h-2.5 w-2.5 fill-current" />
                            <span className="ml-3" aria-hidden="true">
                                {player.playing ? 'Pause' : 'Listen'}
                            </span>
                        </a>
                        {/*
                        <span aria-hidden="true" className="text-sm font-bold text-slate-400">
                            /
                        </span>
                        <Link 
                            href={`/${episode.id}`}
                            className="flex items-center text-sm font-bold leading-6 text-brand hover:text-gray-700 active:text-gray-900"
                            aria-label={`Show notes for episode ${episode.title}`}
                        >
                            Show notes
                        </Link>
                        */}
                    </div>
                </div>
            </Container>
        </article>
    );
};

export default EpisodeEntry;
